import request from '@/utils/request';
// const token = "rjc1fm7it2nm6apnr3uijjq1og"
var url = location.search;
if (url.indexOf("?") != -1) {  
//   var strs = url.substr(1).split("=")[1].split("&")[0];
  var strs = url.substr(1).split("&")[0].split("=")[1]
} 
const getApiPath = () => {
    const urlParams = new URLSearchParams(window.location.search);
    // 将 URLSearchParams 转换为对象
    const params = Object.fromEntries(urlParams.entries());

    const apiPath = !params['SHOP_ID'] || params['SHOP_ID'] == 0?'store':'storeAdmin'


    return apiPath
}

const apiPath = getApiPath()

export const getTemplate = () => {
    return request.get(`/${apiPath}/goods_price_template/lists?TOKEN_SESSION=${strs}`)
}

export const deleteTemplate = (id) => {
    return request.get(`/${apiPath}/goods_price_template/delete?TOKEN_SESSION=${strs}`,{
        params: {
            id
        }
    })
}

export const updateTemplate = ({goods_price_template_id, formula, name}) => {
    return request.post(`/${apiPath}/goods_price_template/update?TOKEN_SESSION=${strs}`,{
        goods_price_template_id, 
        formula, 
        name
    })
}

export const createTemplate = (formula, name) => {
    return request.post(`/${apiPath}/goods_price_template/create?TOKEN_SESSION=${strs}`,{ 
        formula, 
        name
    })
}

//获取自定义代数
export const getParameter = () =>{
    return request.get(`/${apiPath}/goods_price_parameter/lists?TOKEN_SESSION=${strs}`)
}

//新建自定义代数
export const createParameter = ( name, key, value) => {
    return request.post(`/${apiPath}/goods_price_parameter/create?TOKEN_SESSION=${strs}`,{
        name,
        key, 
        value
    })
}

//更新自定义代数
export const updateParameter = ( id, name, key, value) => {
    return request.post(`/${apiPath}/goods_price_parameter/update?TOKEN_SESSION=${strs}`,{
        id,
        name,
        key, 
        value
    })
}

//删除自定义代数
export const deleteParameter = (id) => {
    return request.get(`/${apiPath}/goods_price_parameter/delete?TOKEN_SESSION=${strs}`,{
        params: {
            id
        }
    })
}


//一键更新价格
// export const allUpdate = (  ) => {
//     return request.post(`/store/goods_price/allUpdate?TOKEN_SESSION=${strs}`,{
        
//     })
// }
export const allUpdate = params =>request.post(`/${apiPath}/goods_price/allUpdate?TOKEN_SESSION=${strs}`,params)
